import React, {createContext, useState, useContext, useEffect} from 'react';
import axios from "axios";
export const AuthContext = createContext({
    isAuthenticated: false,
    login: () => {},
});

export const AuthProvider = ({ children }) => {
    const [isAuthenticated, setIsAuthenticated] = useState(false);
    const [authToken, setAuthToken] = useState(localStorage.getItem("jwtToken") || null);

    const login = (token) => {
        localStorage.setItem("jwtToken", token);
        setAuthToken(token);
        setIsAuthenticated(true);
    };

    const logout = () => {
        localStorage.removeItem("jwtToken");
        setAuthToken(null);
        setIsAuthenticated(false);
    };

    useEffect(() => {
        async function checkToken() {
            if (!authToken) {
                setIsAuthenticated(false);
                return;
            }
            try {
                const url = `${process.env.REACT_APP_API_BASE_URL}/User/CheckTokenValidation`;
                const { data } = await axios.get(url, { params: { Token: authToken } });
                if (!data?.success) {
                    logout();
                } else {
                    const expiration = data?.data?.expirtaion;
                    const isExpired = expiration && new Date(expiration).getTime() <= Date.now();
                    if (isExpired) logout();
                    else setIsAuthenticated(true);
                }
            } catch {
                logout();
            }
        }

        checkToken();

        const handleStorageChange = (event) => {
            if (event.key === "jwtToken") {
                const newToken = localStorage.getItem("jwtToken");
                setAuthToken(newToken);
            }
        };

        window.addEventListener("storage", handleStorageChange);

        const tokenPoller = setInterval(() => {
            const currentToken = localStorage.getItem("jwtToken");
            if (currentToken !== authToken) {
                setAuthToken(currentToken);
            }
        }, 1000);

        return () => {
            window.removeEventListener("storage", handleStorageChange);
            clearInterval(tokenPoller);
        };
    }, [authToken]);

    return (
        <AuthContext.Provider value={{ isAuthenticated, login }}>
            {children}
        </AuthContext.Provider>
    );
};

export const useAuth = () => useContext(AuthContext);
